import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {
      user: {
        id: localStorage.getItem("yallaQata_Admin_Dash_User_Id"),
        token: localStorage.getItem("yallaQata_Admin_Dash_Token"),
        usertype: localStorage.getItem("yallaQata_Admin_Dash_User_Type"),
        name: localStorage.getItem("yallaQata_Admin_Dash_User_name"),
        image: localStorage.getItem("yallaQata_Admin_Dash_userImg"),
        phone: localStorage.getItem("yallaQata_Admin_Dash_userPhone"),
      },
    };
  },
  mutations,
  actions,
  getters,
};

